<template>
  <div id="wrap">
    <el-alert
      title="温馨提示：您在公司宝购买了下属商标驳回复审，根据商标局的要求需要您提供相应的文件材料，提交商标驳回复审时效为您接收到驳回通知15日内，请尽快支付并补充材料，以免错过申请时间。"
      type="warning"
      show-icon
      :closable="false"
    ></el-alert>
    <div class="content">
      <div class="mainPart">
        <h3>订单信息</h3>
        <el-table
          :data="tableData"
          style="width: 100%;"
          :header-cell-style="tableClass"
          :cell-style="numRowStable"
        >
          <el-table-column prop="name" label="服务名称" width="180"></el-table-column>
          <el-table-column prop label="商标图样">
            <template>
              <img :src="tableData[0].type" alt style="width: 50px" />
            </template>
          </el-table-column>
          <el-table-column prop label="类别">
            <span v-show="tableData[0].category">第0{{ tableData[0].category}}类</span>
          </el-table-column>
          <el-table-column prop="applicationNumber" label="商标申请号"></el-table-column>
          <el-table-column prop="issueNumber" label="知识产权局发文号" width="180"></el-table-column>
          <el-table-column prop label="金额">
            <span v-show="tableData[0].amount">￥{{ tableData[0].amount }}</span>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer">
      <div class="matter">
        <div class="num" style="width: 31%; text-align: right; margin-left: 600px">
          <span>应付金额：</span>
          <i>￥</i>
          <span class="price">{{payPrice}}</span>
          <el-checkbox v-model="agree" @click="agreeA()">
            我已阅读，理解并接受
            <em style="color: #00B2FF;">《商标服务条款》</em>
          </el-checkbox>
        </div>
        <el-button @click="pay()">确认支付</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { createReviewOrder } from "@/api/fill.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      agree: false,
      payPrice: this.$store.state.brandReview.PFproductList.price,
      tableData: [
        {
          name: '', //服务名称
          type: '',//商标图样
          category: '', //商标类别
          applicationNumber: '', //申请号
          issueNumber: '',// 发文号
          amount: '', //价格
        },
      ],
    };
  },
  methods: {
    agreeA() {
      this.agree = !this.agree;
    },
    numRowStable({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 5) {
        return "color: #FF7724;";
      }
    },
    pay() {
      let params = {
        channelItemCode: this.PFproductList.channel_item_code,
        channelItemAppendName: this.PFproductList.channel_item_name,
        payCode: this.PFproductList.pay_code,
        quantity: 1,
        totalSum: this.PFproductList.price,
        payTotalSum: 1 * this.PFproductList.price,
        notes: "订单备注信息",
        orderContact: {
          contacts: this.PFcontactInfo.contactName,
          mobile: this.PFcontactInfo.contactTel,
          email: this.PFcontactInfo.contactEml,
        },
        channelOrder: {},
        deliveryData: {
          apply: {
            askforId: this.PFreviewInfo.caseNumber,
            tradeImg: this.PFreviewInfo.type,
            tradeType: this.PFreviewInfo.brandType,
            applicantName: this.PFreviewInfo.applicantName,
            usccode: this.PFreviewInfo.assistant,
            agentName: this.PFreviewInfo.agent,
          },
          applyUser: {
            applicantName: "",
            applicantType: "",
            usccode: "",
            licenseAddr: "",
            licenseDir: "",
            duty: "",
            tel: this.PFcontactInfo.contactTel,
            addr: this.PFcontactInfo.contactAddr,
            entrust: "",
            country: "",
            dutyName: "",
            contactsName: "",
            email: this.PFcontactInfo.contactEml,
            mailCode: "",
          },
          trademarkRejInfo: {},
          askForData: {},
          supData: {
            dir: "",
            con: "",
          },
        },
      };
      if (this.agree == true) {
        createReviewOrder(params).then((res) => {
          if (res.status == 0) {
            this.$router.push({
              path: "/brandReview/cashier",
              query: {
                payNo: res.data.channelOrderNo,
                payMoney: this.payPrice,
                serveItem: this.tableData[0].name,
              },
            });
          }
        });
      } else {
        this.$message({
          message: "请先理解并接受《商标服务条款》",
          type: "warning",
        });
      }
    },
  },
  computed: {
    tableClass() {
      return {
        background: "rgba(247,252,255,1)",
        border: "none",
        height: "40px",
      };
    },
    ...mapState({
      PFcontactInfo: (state) => state.brandReview.PFcontactInfo,
      PFreviewInfo: (state) => state.brandReview.PFreviewInfo,
      PFproductList: (state) => state.brandReview.PFproductList,
    }),
  },
  created() {},
  mounted() {
    this.$store.commit("qffillmaterials/changeActivedIndex", 2);
    this.tableData[0].name = this.PFproductList.channel_item_name//服务名称
    this.tableData[0].type = this.PFreviewInfo.type//商标图样
    this.tableData[0].category = this.PFreviewInfo.brandType //商标类别
    this.tableData[0].applicationNumber = this.PFreviewInfo.caseNumber//申请号
    this.tableData[0].issueNumber = this.PFreviewInfo.postNo// 发文号
    this.tableData[0].amount = this.PFproductList.price //价格
  },
};
</script>
<style lang="scss" scoped>
#wrap {
  .el-alert {
    width: 80%;
    margin: 0 auto;
    background-color: #d6e7ff;
    color: #3c74cb;
    font-size: 12px;
    margin-bottom: 20px;
    box-shadow: 0px -1px 0px 0px rgba(221, 221, 221, 1);
    /deep/.el-alert__title {
      font-size: 12px;
    }
  }
  .content {
    width: 80%;
    height: 402px;
    background-color: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    margin: 0 auto;
    margin-bottom: 40px;
    box-shadow: 0px -1px 0px 0px rgba(221, 221, 221, 1);
    .mainPart {
      width: 96%;
      margin: 0 auto;
      h3 {
        font-weight: 900;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      /deep/.num {
        color: #ff7724;
      }
    }
  }
  .footer {
    position: absolute;
    width: 100%;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .matter {
      position: absolute;
      right: 190px;
      bottom: 22px;
      display: flex;
      align-items: center;
      .num {
        display: inline-block;
        i {
          color: #ff6a01;
        }
        .price {
          font-size: 28px;
          font-weight: 900;
          color: #ff6a01;
        }
      }
      .el-button {
        background-color: #ff6a01;
        font-size: 16px;
        width: 145px;
        height: 44px;
        color: #fff;
        margin-left: 30px;
        border-radius: 0px;
      }
    }
  }
}
</style>